/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from "@angular/core";
import {AbstractResourceService} from "@irian-ro/abstract-resource";
import { HttpClient } from "@angular/common/http";
import {EnvironmentService} from "@irian-ro/util-environment";

@Injectable({
    providedIn: 'root'
})
export class DeliveryEmployeeResourceService extends AbstractResourceService<
    any,
    any,
    null,
    null
> {
    constructor(
        protected httpClient: HttpClient,
        private environmentService: EnvironmentService
    ) {
        super(
            httpClient,
            environmentService.getEnvironmentProperty('deliveryEmployeeVOsUrl'),
            undefined,
            undefined,
            undefined,
            undefined
        );
    }
}
